import React, { useState } from 'react';
import { Plus, Check, X } from 'lucide-react';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { stagesApi } from '../services/stagesApi';
import { toast } from '@/hooks/use-toast';

interface AddStageProps {
  onStageCreated: () => void;
}

const AddStage: React.FC<AddStageProps> = ({ onStageCreated }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [stageName, setStageName] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  const handleCreate = async () => {
    if (!stageName.trim()) {
      toast.error('El nombre de la etapa no puede estar vacío');
      return;
    }

    try {
      setIsCreating(true);
      await stagesApi.createStage(stageName);
      toast.success('Etapa creada exitosamente');
      setStageName('');
      setIsEditing(false);
      onStageCreated();
    } catch (error) {
      console.error('Error creating stage:', error);
      toast.error('Error al crear la etapa');
    } finally {
      setIsCreating(false);
    }
  };

  const handleCancel = () => {
    setStageName('');
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className="p-4 border-2 border-primary rounded-xl shadow-md flex flex-col items-start justify-start space-y-3 w-full bg-white">
        <h3 className="font-medium text-gray-900 text-sm">Nueva etapa</h3>
        <Input
          value={stageName}
          onChange={(e) => setStageName(e.target.value)}
          placeholder="Nombre de la etapa"
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleCreate();
            if (e.key === 'Escape') handleCancel();
          }}
        />
        <div className="flex gap-2 w-full">
          <Button
            size="sm"
            onClick={handleCreate}
            disabled={isCreating || !stageName.trim()}
            className="flex-1"
          >
            <Check className="w-4 h-4 mr-1" />
            Crear
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={handleCancel}
            disabled={isCreating}
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="p-4 border-2 border-dashed border-gray-300 hover:border-primary transition-colors cursor-pointer flex flex-col items-center justify-center text-center space-y-3 shadow w-full bg-white rounded-xl"
      onClick={() => setIsEditing(true)}
    >
      <div className="w-10 h-10 rounded-full border-2 border-gray-300 hover:border-primary transition-colors flex items-center justify-center">
        <Plus className="w-5 h-5 text-gray-400 hover:text-primary transition-colors" />
      </div>
      <h3 className="font-medium text-gray-700 text-sm">Agregar etapa</h3>
    </div>
  );
};

export default AddStage;
